interface FormulaDisplayProps {
  formula: string
  visible?: boolean
}

export function FormulaDisplay({ formula, visible = true }: FormulaDisplayProps) {
  if (!visible || !formula) return null

  return (
    <pre className="formula-display">
      <code>{formula}</code>
    </pre>
  )
}
